import { createSlice } from '@reduxjs/toolkit';
import { AppInstallationSubscription } from 'hooks/shopify/queries/get-all-app-subscriptions.graphql';
import { getCurrentSubscription } from 'utils/getCurrentSubscription';
import { ShopifyPlansResponse } from '../../../../pb/responses/v1/shopify_plans_response_pb';
import { getShopifyAppPlans, getShopifyAppSubscription } from './shopify-app-pricing.actions';

export interface ShopifyAppPricingState {
    data: ShopifyPlansResponse | null;
    fetching: boolean;
    error: boolean;
    appHandle: string | undefined;
    currentSubscription: AppInstallationSubscription | undefined;
    subscriptionFetching: boolean;
    subscriptionError: boolean;
}

const initialState: ShopifyAppPricingState = {
    data: null,
    fetching: true,
    error: false,
    appHandle: undefined,
    currentSubscription: undefined,
    subscriptionFetching: false,
    subscriptionError: false,
};

const shopifyAppPricingSlice = createSlice({
    name: 'shopifyAppPricing',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getShopifyAppPlans.pending, (state) => {
                state.fetching = true;
                state.error = false;
            })
            .addCase(getShopifyAppPlans.fulfilled, (state, action) => {
                state.data = action.payload;
                state.fetching = false;
            })
            .addCase(getShopifyAppPlans.rejected, (state) => {
                state.fetching = false;
                state.error = true;
            })
            .addCase(getShopifyAppSubscription.pending, (state) => {
                state.subscriptionFetching = true;
                state.subscriptionError = false;
            })
            .addCase(getShopifyAppSubscription.fulfilled, (state, action) => {
                state.appHandle = action.payload.currentAppInstallation?.app?.handle;
                state.currentSubscription = getCurrentSubscription(action.payload.currentAppInstallation);
                state.subscriptionFetching = false;
            })
            .addCase(getShopifyAppSubscription.rejected, (state) => {
                state.subscriptionFetching = false;
                state.subscriptionError = true;
            });
    },
});

export default shopifyAppPricingSlice.reducer;
